// ============================================
// Clack Republic — Dark RGB Landing Page
// Smooth nav scroll + cart interactions
// (Waitlist form submits natively to Shopify's customer form — no JS interception)
// ============================================

(function () {
  "use strict";

  /* ---------- Waitlist Form: client-side email format check only ---------- */
  /* Actual submission is handled natively by Shopify's customer form (POST /contact#waitlist_form) */
  var form = document.getElementById("waitlist-form");
  var emailInput = document.getElementById("waitlist-email");

  function isValidEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  if (form && emailInput) {
    form.addEventListener("submit", function (e) {
      var value = emailInput.value.trim();
      if (!isValidEmail(value)) {
        e.preventDefault();
        emailInput.classList.add("invalid");
        return;
      }
      emailInput.classList.remove("invalid");
    });

    emailInput.addEventListener("input", function () {
      emailInput.classList.remove("invalid");
    });
  }

  /* ---------- AK820 Product Gallery ---------- */
  var galleryImage = document.getElementById("ak820-gallery-image");
  var galleryThumbs = document.getElementById("ak820-gallery-thumbs");
  var galleryCounter = document.getElementById("ak820-gallery-counter");
  var galleryPrev = document.getElementById("ak820-gallery-prev");
  var galleryNext = document.getElementById("ak820-gallery-next");

  var galleryExpand = document.getElementById("ak820-gallery-expand");
  var lightbox = document.getElementById("ak820-gallery-lightbox");
  var lightboxImage = document.getElementById("ak820-lightbox-image");
  var lightboxCounter = document.getElementById("ak820-lightbox-counter");
  var lightboxClose = document.getElementById("ak820-lightbox-close");
  var lightboxPrev = document.getElementById("ak820-lightbox-prev");
  var lightboxNext = document.getElementById("ak820-lightbox-next");

  if (galleryImage && galleryThumbs) {
    var thumbs = Array.prototype.slice.call(galleryThumbs.querySelectorAll(".gallery-thumb"));
    var galleryIdx = 0;
    var lightboxOpen = false;

    function renderGallery() {
      var thumb = thumbs[galleryIdx];
      galleryImage.src = thumb.getAttribute("data-image");
      galleryImage.alt = thumb.getAttribute("data-alt");
      if (galleryCounter) galleryCounter.textContent = (galleryIdx + 1) + " / " + thumbs.length;
      thumbs.forEach(function (t, i) {
        t.classList.toggle("active", i === galleryIdx);
        if (i === galleryIdx) {
          t.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
        }
      });
      if (lightboxOpen && lightboxImage) {
        lightboxImage.src = thumb.getAttribute("data-image");
        lightboxImage.alt = thumb.getAttribute("data-alt");
        if (lightboxCounter) lightboxCounter.textContent = (galleryIdx + 1) + " / " + thumbs.length;
      }
    }

    galleryThumbs.addEventListener("click", function (e) {
      var btn = e.target.closest(".gallery-thumb");
      if (!btn) return;
      galleryIdx = thumbs.indexOf(btn);
      renderGallery();
    });

    if (galleryPrev) {
      galleryPrev.addEventListener("click", function () {
        galleryIdx = (galleryIdx - 1 + thumbs.length) % thumbs.length;
        renderGallery();
      });
    }

    if (galleryNext) {
      galleryNext.addEventListener("click", function () {
        galleryIdx = (galleryIdx + 1) % thumbs.length;
        renderGallery();
      });
    }

    function openLightbox() {
      if (!lightbox) return;
      lightboxOpen = true;
      lightbox.hidden = false;
      document.body.style.overflow = "hidden";
      renderGallery();
      if (lightboxClose) lightboxClose.focus();
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightboxOpen = false;
      lightbox.hidden = true;
      document.body.style.overflow = "";
      if (galleryExpand) galleryExpand.focus();
    }

    if (galleryImage) galleryImage.addEventListener("click", openLightbox);
    if (galleryExpand) galleryExpand.addEventListener("click", openLightbox);
    if (lightboxClose) lightboxClose.addEventListener("click", closeLightbox);

    if (lightboxPrev) {
      lightboxPrev.addEventListener("click", function () {
        galleryIdx = (galleryIdx - 1 + thumbs.length) % thumbs.length;
        renderGallery();
      });
    }

    if (lightboxNext) {
      lightboxNext.addEventListener("click", function () {
        galleryIdx = (galleryIdx + 1) % thumbs.length;
        renderGallery();
      });
    }

    if (lightbox) {
      lightbox.addEventListener("click", function (e) {
        if (e.target === lightbox) closeLightbox();
      });
    }

    document.addEventListener("keydown", function (e) {
      if (!lightboxOpen) return;
      if (e.key === "Escape") closeLightbox();
      if (e.key === "ArrowLeft" && lightboxPrev) lightboxPrev.click();
      if (e.key === "ArrowRight" && lightboxNext) lightboxNext.click();
    });
  }

  /* ---------- AK820 Add to Cart (single launch variant) ---------- */
  var addToCartBtn = document.getElementById("ak820-add-to-cart");
  var buyNowBtn = document.getElementById("ak820-buy-now");
  var cartMsg = document.getElementById("ak820-cart-msg");
  var variantDataEl = document.getElementById("ak820-variant-data");

  if (variantDataEl) {
    var variant = JSON.parse(variantDataEl.textContent);
    var stockPill = document.getElementById("ak820-stock-pill");

    function showMessage(text, type) {
      if (!cartMsg) return;
      cartMsg.textContent = text;
      cartMsg.classList.remove("success", "error");
      cartMsg.classList.add(type);
    }

    function decrementStock() {
      if (typeof variant.inventory !== "number") return;
      variant.inventory = Math.max(0, variant.inventory - 1);
      if (variant.inventory <= 0) {
        variant.available = false;
        if (stockPill) {
          stockPill.textContent = "Out of Stock";
          stockPill.classList.remove("stock-in");
          stockPill.classList.add("stock-out");
        }
        if (addToCartBtn) {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = "Out of Stock";
        }
        if (buyNowBtn) {
          buyNowBtn.disabled = true;
          buyNowBtn.textContent = "Out of Stock";
        }
      } else if (stockPill) {
        stockPill.textContent = variant.inventory + " in stock, ships today";
      }
    }

    function addToCart() {
      return fetch(Theme.routes.cart_add_url, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: variant.variantId, quantity: 1 }],
          sections: "cart-drawer-section",
          sections_url: window.location.pathname,
        }),
      }).then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) throw data;
          return data;
        });
      });
    }

    function refreshCartDrawer(sections) {
      var html = sections && sections["cart-drawer-section"];
      var wrapper = document.getElementById("shopify-section-cart-drawer-section");
      if (!html || !wrapper) return;

      var parsed = new DOMParser().parseFromString(html, "text/html");
      var newWrapper = parsed.getElementById("shopify-section-cart-drawer-section");
      if (newWrapper) wrapper.innerHTML = newWrapper.innerHTML;

      var countEl = document.getElementById("ak820-cart-count");
      var newCount = parsed.querySelector('[ref="cartItemCount"]');
      if (countEl && newCount) {
        var count = newCount.textContent.trim();
        countEl.textContent = count;
        countEl.style.display = count === "0" ? "none" : "flex";
      }
    }

    function openCartDrawer() {
      var drawer = document.getElementById("cart-drawer");
      if (drawer && typeof drawer.open === "function") drawer.open();
    }

    if (addToCartBtn) {
      addToCartBtn.disabled = !variant.available;
      addToCartBtn.addEventListener("click", function () {
        addToCartBtn.disabled = true;
        addToCart()
          .then(function (data) {
            showMessage("Added to cart.", "success");
            refreshCartDrawer(data.sections);
            openCartDrawer();
            decrementStock();
          })
          .catch(function () {
            showMessage("Not available for purchase yet — join the waitlist above!", "error");
          })
          .finally(function () {
            addToCartBtn.disabled = !variant.available;
          });
      });
    }

    if (buyNowBtn) {
      buyNowBtn.disabled = !variant.available;
      buyNowBtn.addEventListener("click", function () {
        buyNowBtn.disabled = true;
        addToCart()
          .then(function () {
            decrementStock();
            window.location.href = "/checkout";
          })
          .catch(function () {
            showMessage("Not available for purchase yet — join the waitlist above!", "error");
            buyNowBtn.disabled = false;
          });
      });
    }
  }

  /* ---------- Smooth Scroll for Nav Links ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      var targetId = link.getAttribute("href");
      if (targetId.length > 1) {
        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  });
})();
